import { TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box, Button, Switch } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { listService, updateService } from "../services/services";
import moment from "moment";
import { Edit } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";

const Services = () => {

  const [services, set_services] = useState([]);
  const [page, set_page] = useState(0);
  const [count, set_count] = useState(0);
  const [search, set_search] = useState('');

  const getData = async () => {
    const { data } = await listService({
      page: page,
      limit: 10,
      search: search
    })

    if (data) {
      set_services(data.data);
      set_count(data.total_records);
    }
  }

  const handleChangePage = (event, page_no) => {
    set_page(page_no)
  }

  useEffect(() => {
    getData();

    // eslint-disable-next-line
  }, [page, search])

  const handleChangeActiveStatus = async (status, id) => {
    const { data, error } = await updateService({
      data: {
        active: status
      },
      id: id
    });

    if (data) {
      getData();
      enqueueSnackbar('Status updated successfully', {
        variant: 'success'
      })
    }
    if (error) {
      enqueueSnackbar('Error while updating status', {
        variant: 'error'
      })
    }
  }

  return (
    <Wrapper>
      <Box
        component='div'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <TextField
          label='Search'
          sx={{
            width: '450px'
          }}
          value={search}
          onChange={(e) => set_search(e.target.value)}
        />

        <Link
          className="d-inline-block"
          to='/add-service'
        >
          <Button
            variant="contained"
          >
            Add new
          </Button>
        </Link>
      </Box>

      <Paper
        elevation={4}
        sx={{
          marginTop: '20px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Sr No.
              </TableCell>
              <TableCell>
                Service
              </TableCell>
              <TableCell>
                Type
              </TableCell>
              <TableCell>
                Modality
              </TableCell>
              <TableCell>
                Price
              </TableCell>
              <TableCell>
                Status
              </TableCell>
              <TableCell>
                Created At
              </TableCell>
              <TableCell>
                Edit
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {
              services.map((service, ind) => {
                return (
                  <TableRow
                    key={service._id}
                  >
                    <TableCell>
                      {ind + 1}
                    </TableCell>
                    <TableCell>
                      {service.name}
                    </TableCell>
                    <TableCell>
                      {Array.isArray(service.type) ? service.type.join(', ') : service.type}
                    </TableCell>
                    <TableCell>
                      {service.modality}
                    </TableCell>
                    <TableCell>
                      {service.price} Rs / {service.price_per}
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={service.active}
                        onChange={(e) => handleChangeActiveStatus(e.target.checked, service._id)}
                      />
                    </TableCell>
                    <TableCell>
                      {moment(service.created_at).format('DD-MM-YYYY hh:mm A')}
                    </TableCell>
                    <TableCell>
                      <Link to={`/edit-service/${service._id}`}>
                        <Edit />
                      </Link>
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
          onPageChange={handleChangePage}
        />
      </Paper>

    </Wrapper>
  )
}

export default Services;